import Vue from 'vue'

// 插件
import 'plugins/Message'
import 'plugins/Loading'

import 'conf/toase'
import 'conf/store'
import 'conf/adapt'
import 'conf/axios'
import './assets/icon/iconfont.css'
import 'utils/element'


import Clipboard from 'utils/clipboard'
// 全局使用复制方法
window.clipboard = txt => {
  Clipboard(txt)
}

import App from './App.vue'
import router from 'conf/router'

Vue.config.productionTip = false


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')




